import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

// Admin edition switcher — when an admin selects a past edition, every /admin GET is
// scoped to it so views never mix data across editions. Default (null) = active edition.
let _adminEditionId = null;
export const setAdminEditionId = (id) => { _adminEditionId = id || null; };
export const getAdminEditionId = () => _adminEditionId;

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  const url = config.url || "";
  if (_adminEditionId && method === "get" && url.includes("/admin/") && !url.includes("/admin/editions")) {
    config.params = { ...(config.params || {}), edition_id: _adminEditionId };
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => Promise.reject(err)
);

export const errorMessage = (err) =>
  err?.response?.data?.detail ||
  (Array.isArray(err?.response?.data) && err.response.data[0]?.msg) ||
  err?.message ||
  "Something went wrong";
